import BotConditionCard from "./BotConditionCard";
import React from "react";
import {useWatch} from "react-hook-form";
import ReactHookFormCheckbox from "../../input/ReactHookFormCheckbox";
import ReactHookFormRadio from "../../input/ReactHookFormRadio";
import OSMultiSelect from "../../campaigns/conditions/OSMultiSelect";
import {Add, Delete} from "@mui/icons-material";
import {Box, Button, IconButton} from "@mui/material";

function BotConditionOS(props) {
    const {control, setValue, getValues} = props;

    // Watch the global rules object in real-time
    const rules = useWatch({control, name: "rules"}) || {};
    const osData = rules?.os;
    const hasOsCondition = !!osData;

    const radioConditions = [
        {label: "Is", value: "is", color: "primary"},
        {label: "Is not", value: "isNot", color: "error"},
    ];

    // REMOVE: Safe JS delete approach
    const removeCondition = () => {
        const currentRules = {...getValues("rules")};
        delete currentRules.os;
        setValue("rules", currentRules);
    };

    // ADD: Initialize flat os object
    const addCondition = () => {
        setValue("rules.os", {
            condition: "is",
            includeEmptyValue: false,
            values: []
        });
    };

    const renderAddCondition = () => {
        if (!hasOsCondition) {
            return (
                <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
                    <Box flexGrow={1} sx={{minWidth: 0, fontSize: 14, fontWeight: 600}}>
                        <span>OS</span>
                    </Box>
                    <Box>
                        <Button
                            aria-label="condition"
                            color="primary"
                            title="Add condition"
                            startIcon={<Add/>}
                            onClick={addCondition}
                            sx={{textTransform: "none", py: 0.25, px: 1}}
                        >
                            Add condition
                        </Button>
                    </Box>
                </Box>
            );
        }
    };

    const renderConditionBox = () => {
        if (hasOsCondition) {
            return (
                <>
                    <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
                        <Box flexGrow={1} sx={{minWidth: 0, fontSize: 14, fontWeight: 600}}>
                            OS
                        </Box>
                        <Box>
                            <IconButton
                                aria-label="remove"
                                color="default"
                                title="Remove"
                                size="small"
                                onClick={removeCondition}
                                sx={{color: 'error.dark'}}
                            >
                                <Delete fontSize="small"/>
                            </IconButton>
                        </Box>
                    </Box>
                    <Box>
                        <ReactHookFormRadio
                            control={control}
                            options={radioConditions}
                            name="rules.os.condition"
                            label="conditions"
                        />
                    </Box>
                    <Box>
                        <ReactHookFormCheckbox
                            control={control}
                            label="Include empty value"
                            labelPlacement="end"
                            name="rules.os.includeEmptyValue"
                        />
                    </Box>
                    <Box sx={{mt: 1}}>
                        <OSMultiSelect
                            control={control}
                            inputName="rules.os.values"
                            inputLabel="OS"
                        />
                    </Box>
                </>
            );
        }
    };

    return (
        <BotConditionCard>
            {renderAddCondition()}
            {renderConditionBox()}
        </BotConditionCard>
    );
}

export default BotConditionOS;
